import { Component } from '@angular/core';

@Component({
    selector: 'bb-tooltip-page-ui',
    templateUrl: './bb-tooltip-page-ui.component.html',
    standalone: false,
})
export class TooltipPageComponent {}
